module.exports = __webpack_public_path__ + "static/media/Hbook-01.efcfefba.jpg";